export default __webpack_public_path__ + "static/media/Update.2ebba68a.png";